"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Waternetwork = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'Waternetwork';
class Waternetwork extends datamodel_core_1.ModelCommon {
    constructor(ob) {
        var _a, _b, _c, _d;
        super(ob.type || typeName, ob);
        this.purpose = (_a = ob.purpose) !== null && _a !== void 0 ? _a : '';
        this.networktype = (_b = ob.networktype) !== null && _b !== void 0 ? _b : '';
        this.linkedEntity = (_c = ob.linkedEntity) !== null && _c !== void 0 ? _c : [];
        this.name = (_d = ob.name) !== null && _d !== void 0 ? _d : '';
        this.position = ob.position;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of WaterNetwork',
            },
            purpose: {
                type: 'String',
                editable: true,
                label: 'Purpose',
                name: 'purpose',
                description: 'Used for',
            },
            networktype: {
                type: 'String',
                editable: true,
                label: 'Network type',
                name: 'Networktype',
                description: 'Used for',
            },
        };
    }
}
exports.Waternetwork = Waternetwork;
